<template>
  <div style="display:flex;flex-direction:column;">
    <Row v-for="(i, ix) in order_list" :key="ix" type="flex" justify="start" :gutter="16">
      <i-col :xs="24" :sm="isMobile ? 12 : 24" :lg="isMobile ? 24 : 8" :xxl="isMobile ? 24 : 6"
        v-for="(room, index) in rooms.filter(j => Math.floor(j.order_number / 1000) === i)" :key="index">
        <div :class="isMobile ? 'litem mobile' : 'litem'">
          <div class="leftbar">
            <div class="wrap" @click="$emit('routerswitch', { name: 'meetingRoomDetail', params: { id: room.id } })">
              <div class="back" :style="room.caution ? 'background:#e88b48;' : ''">{{ room.caution || room.introduction
      ||
      '本会议室服务于广大师生！' }}</div>
              <img class="cover" style="width:100%;height: inherit;" alt=""
                :src="room.image ? 'https://biocore.sjtu.edu.cn/static/assets/img/' + room.image : 'https://biocore.sjtu.edu.cn/assets/imgs/room.jpg'">
              <Badge v-if="$store.state.user.lab_role >= 255" :count="room.count || 0"></Badge>
              </img>
            </div>
          </div>
          <div class="rightbar">
            <div class="base-info">
              【{{ room.name }}】
            </div>
            <div class="details">
              管理员 {{ room.admin_name }}
            </div>
            <div class="details">
              面积 {{ room.area }}平方米
            </div>
            <div class="details">
              容量 {{ room.capacity }}人
            </div>
            <Button :disabled="room.open === 0" size="large" type="primary" @click="appointment(room)"
              :title="room.caution" style="background:#27A55D;border-color:rgb(215, 232, 249);color:#fff;">
              立即预约
            </Button>
            <Button v-if="((user.current_org.org_role || {}).role_list || []).find(i => [1001, 1010].includes(i.id))"
              size="large" shape="circle" @click="open(room)"
              style="margin-top:10px;background:rgb(31, 174, 47);border:none;color:#fff;">
              开门
            </Button>
          </div>
        </div>
      </i-col>
      <i-col span="24">
        <Divider v-if="ix < order_list.length - 1" />
      </i-col>
    </Row>
  </div>
</template>
<style scoped>
.litem {
  box-shadow: 3px 3px 0.7em rgba(0, 0, 0, 0.2);
  max-height: 200px;
  display: flex;
  flex-direction: row;
  height: 200px;
  margin: 10px 0;
}

.litem.mobile {
  max-height: 300px;
  height: 300px;
}

.leftbar {
  flex: 3;
}

.leftbar .wrap {
  cursor: pointer;
}

.wrap {
  transition: all 0.4s ease;
  -webkit-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
  height: 100%;
  width: 100%;
  padding: 0;
}

.cover {
  z-index: 2;
  position: relative;
  backface-visibility: hidden;
}

.back {
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(39, 165, 93, 0.8);
  color: #fff;
  padding: 0.5em;
  -webkit-transform: rotateY(-180deg);
  -ms-transform: rotateY(180deg);
  -moz-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  border-radius: 0.5em;
}

.leftbar:hover>.wrap {
  -webkit-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  transform: rotateY(180deg);
}

.leftbar:hover .back {
  box-shadow: 0 0 30px rgba(169, 255, 176, 0.6);
}

.leftbar:hover:after {
  background: #804;
}

.rightbar {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.base-info,
.details {
  min-width: 80%;
  display: flex;
  justify-content: center;
}

.base-info {
  color: #2b656b;
}
</style>

<script>
export default {
  data: function () {
    return {
      rooms: [],
      initparam: this.$store.state.initparam,
      showList: [],
      order_list: [],
    };
  },

  watch: {
    $route(to, fr) {
      console.log(to.fullPath, fr.fullPath);
      this.init();
    },
    "$store.state.search": function (s) {
      for (let i = 0; i < this.showList.length; i++) {
        if (
          this.rooms[i].name.indexOf(s) > -1 ||
          this.rooms[i].introdcution.indexOf(s) > -1
        ) {
          this.$set(this.showList, i, true);
        } else {
          this.$set(this.showList, i, false);
        }
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isMobile() {
      return (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) || document.body.clientWidth < 991
      );
    },
  },
  created() {
    //scrollTo(0,0)
    this.init();
  },
  methods: {
    init() {
      if (Object.keys(this.$route.params).length === 0) {
        let p = this.$store.state.routerViews.rooms;
        for (let i in p) {
          this.$route.params[i] = p[i];
        }
      }
      this.db_api("post", this.api, { req: "get_meeting_rooms" }).then((res) => {
        for (let i = 0; i < res[0].result.length; i++) {
          this.showList.push(true);
        }
        this.rooms = res[0].result;
        let order_set = new Set([]);
        for (let i of res[0].result.filter((j) => j.order_number > 1000)) {
          order_set.add(Math.floor(i.order_number / 1000));
        }
        this.order_list = Array.from(order_set).sort().reverse();
      });
    },
    open(room) {
      this.$Message.info("开启中……");
      this.db_api("post", this.api, {
        req: "open_door_by_assets",
        assets_id: room.id,
        operation: 1,
      }).then((res) => {
        let ret = res[0].result;
        if (ret[0][2] === "success") {
          this.$Message.info("操作成功！");
        } else if (ret[0][2] === "no device") {
          this.$Message.warning("无可操作门禁！");
        } else if (ret[0][2] === "hanging") {
          this.$Message.info("操作中……");
        } else if (ret[0][2] === "timeout") {
          this.$Message.error("操作超时……");
        } else {
          this.$Message.error("操作失败！");
        }
      });
    },
    appointment(room) {
      if (!this.$store.state.user.id) {
        this.$emit("childEvent", { cmd: "showlogin" });
        return;
      }
      if (
        this.$store.state.user.org_id.toString().indexOf("10110001008") ===
        -1 &&
        this.$store.state.user.org_id !== 10110001
      ) {
        return this.$Message.warning("您不是生命学院的用户！");
      }
      this.$emit("routerswitch", {
        name: "appointment",
        params: {
          req: "get_meeting_room_appointments_by_id",
          id: room.id,
        },
      });
    },
  },
  mounted() { },
  components: {},
};
</script>
